import { generatePresignedUrl, uploadToS3 } from "@/api/utils";
import { useMutation } from "@tanstack/react-query";
import type { RcFile } from "antd/es/upload";

export default function useUpload() {
  const uploadToS3Mutation = useMutation({
    mutationFn: uploadToS3,
  });

  const generatePresignedUrlMutation = useMutation({
    mutationFn: generatePresignedUrl,
  });

  const uploadFile = async (file: RcFile) => {
    const url = await generatePresignedUrlMutation.mutateAsync({ file_name: file.name });

    await uploadToS3Mutation.mutateAsync({
      url: url.url,
      file: file,
    });

    return url;
  };

  return {
    uploadToS3: uploadToS3Mutation,
    generatePresignedUrl: generatePresignedUrlMutation,
    uploadFile,
  };
}
